const FormCheckOptionsWithYesNoLabels = [
    { label: "Yes", value: true },
    { label: "No", value: false },
];

export { FormCheckOptionsWithYesNoLabels };
